
















import {Component, Vue, Model, Watch,Prop} from 'vue-property-decorator';
import _ from 'lodash';
import {currencies as _currencies} from "@/libs/money";

@Component
export default class MoneyEditor extends Vue {
  currencies = _currencies;
  @Model('change', {type: Object})
  readonly value !: { currency: string, amount: number };

  myvalue = 0.00;
  @Prop()
  viewType!:string;

  created() {
    this.myvalue = this.amount;
  }

  selectCurrency(currency: string) {
    this.$emit('change', {currency, amount: this.amount})
  }

  inputAmount(amountStr: string) {
    var myRe = /^[+-]?\d*\.?\d{0,3}$/;

    if (!(myRe.test(amountStr))) {
      return;
    } else if (_.endsWith(amountStr, ".")) {
      // @ts-ignore
      this.myvalue = amountStr;
      return;
    } else if ((amountStr.split('.').length>1)&&_.endsWith(amountStr, "0")) {
      // @ts-ignore
      this.myvalue = amountStr;
      return;
    }

    // @ts-ignore
    this.myvalue = amountStr;

    let amount = amountStr === "" ? 0 : parseFloat(amountStr);
    this.$emit('change', {currency: this.currency, amount});
  }



  get currency(): string {
    console.log("想拿单位的时候先拿的是",this.value.currency);
    return _.get(this.value, 'currency', 'RMB')
  }

  get amount(): number {
    return _.get(this.value, 'amount', 0)
  }

  // currency = 'RMB';
  // amount = 0;
  // created() {
  //   this.setInitData(this.value);
  // }
  //
  // get currency(): string {
  //   return _.get(this.value, 'currency', 'RMB');
  // }
  // setInitData(newVal: any) {
  //   this.currency = _.get(newVal, 'currency', 'RMB');
  //   this.amount = _.get(newVal, 'amount', 0);
  // }
  // @Watch('value') onChangeValue(newVal: any) {
  //   if (!_.isEqual(this.value, newVal)) {
  //     this.setInitData(newVal);
  //   }
  // }

}
